import { print, printDataParse, getNonObjectNonArrayItems } from '@/utils/print';
import { readUserSelect } from '@/utils/myUtils';

// 根据页面值取值  https://www.kdocs.cn/l/cdBR9PscVo48
export const modulesGroupList = {
  '15': {
    object: '',
    key: 'docIds'
  },
  '47': {
    object: '',
    key: 'ids'
  },
  '127': {
    object: '',
    key: 'ids'
  },
  '170': {
    object: '',
    key: 'ids'
  },
  '172': {
    object: '',
    key: 'ids'
  },
  '199': {
    object: '',
    key: 'ids'
  }
};

export const modulesList = {
  '11': {
    key: ['customerId'],
    value: ['customerId']
  },
  '16': {
    key: ['purchasesReceiptDocId'],
    value: ['purchasesReceiptDocId']
  },
  '18': {
    key: ['repaymentDocId'],
    value: ['repaymentDocId']
  },
  '19': {
    key: ['salesDeliveryDocId'],
    value: ['docId']
  },
  '21': {
    key: ['salesQuotationOrderDocId'],
    value: ['salesQuotationOrderDocId']
  },
  '22': {
    key: ['salesOrderDocId'],
    value: ['salesOrderDocId']
  },
  '23': {
    key: ['materialId', 'specGroupId', 'salesDeliveryDocId'],
    value: ['baseMetaMaterialId', 'baseMetaSpecgroupId', 'salesDeliveryDocId']
  },
  '24': {
    key: ['salesSampleOrderDocId'],
    value: ['salesSampleOrderDocId']
  },
  '15': {
    key: ['purchasesOrderDocId'],
    value: ['purchasesOrderDocId']
  },
  '31': {
    key: ['purchasesOrderDocId'],
    value: ['purchasesOrderDocId']
  },
  '32': {
    key: ['proddocReturnDoc_view', 'purchasesReceiptDocId'],
    value: ['proddocReturnDoc_view', 'purchasesReceiptDocId']
  },
  '33': {
    key: ['reportId'],
    value: ['reportId']
  },
  '34': {
    key: ['purchaseRequisitionDocId'],
    value: ['purchaseRequisitionDocId']
  },
  '41': {
    key: ['produceDocId'],
    value: ['produceDocId']
  },
  '46': {
    key: ['changeBomId'],
    value: ['changeBomId']
  },
  '47': {
    key: ['outsourcingDocId'],
    value: ['outsourcingDocId']
  },
  '48': {
    key: ['outsourcingRequisitionDocId'],
    value: ['outsourcingRequisitionDocId']
  },
  '49': {
    key: ['outsourcingReturnDocId'],
    value: ['outsourcingReturnDocId']
  },
  '50': {
    key: ['outsourcingtowarehouseId'],
    value: ['outsourcingtowarehouseId']
  },
  '51': {
    key: ['salesChargebackDocId'],
    value: ['salesChargebackDocId']
  },
  '53': {
    key: ['testDocId'],
    value: ['testDocId']
  },
  '66': {
    key: ['specGroupId', 'materialId'],
    value: ['specGroupId', 'materialId']
  },
  '71': {
    key: ['bomId'],
    value: ['bomId']
  },
  '72': {
    key: ['mrpDocId'],
    value: ['mrpDocId']
  },
  '73': {
    key: ['reimburseDocId'],
    value: ['reimburseDocId']
  },
  '74': {
    key: ['supplierId'],
    value: ['supplierId']
  },
  '81': {
    key: ['afterSalesSituationId'],
    value: ['afterSalesSituationId']
  },
  '84': {
    key: ['purchasesStatementDocId'],
    value: ['purchasesStatementDocId']
  },
  '93': {
    key: ['statementReceiptDocId'],
    value: ['statementReceiptDocId']
  },
  '94': {
    key: ['statementPaymentDocId'],
    value: ['statementPaymentDocId']
  },
  '96': {
    key: ['produceDocId'],
    value: ['produceDocId']
  },
  '97': {
    key: ['produceDocId'],
    value: ['produceDocId']
  },
  '99': {
    key: ['mrpDocId'],
    value: ['mrpDocId']
  },
  '111': {
    key: ['dailyPaperDocId'],
    value: ['dailyPaperDocId']
  },
  '115': {
    key: ['processRouteId'],
    value: ['processRouteId']
  },
  '117': {
    key: ['materialRequisitionId'],
    value: ['materialRequisitionId']
  },
  '122': {
    key: ['supplementaryMaterialId'],
    value: ['supplementaryMaterialId']
  },
  '127': {
    key: ['processOutsourcingDocId'],
    value: ['processOutsourcingDocId']
  },
  '128': {
    key: ['afterSalesRepairDocId'],
    value: ['afterSalesRepairDocId']
  },
  '138': {
    key: ['purchasesInquiryDocDetailSupplierId'],
    value: ['purchasesInquiryDocDetailSupplierId']
  },
  '139': {
    key: ['meetingsDocId'],
    value: ['meetingsDocId']
  },
  '170': {
    key: ['processOutsourcingRequisitionDocId'],
    value: ['processOutsourcingRequisitionDocId']
  },
  '171': {
    key: ['processOutsourcingReturnDocId'],
    value: ['processOutsourcingReturnDocId']
  },
  /** 工序委外发货（协同端，对应 ERP 工序委外收货 modules=172） */
  '172': {
    key: ['processCoopDeliveryId'],
    value: ['processCoopDeliveryId']
  },
  '199': {
    key: ['processCoopDeliveryId'],
    value: ['processCoopDeliveryId']
  },
  /** 协同库存详情（协同端新建） */
  '195': {
    key: ['outsourcingWarehouseId'],
    value: ['outsourcingWarehouseId']
  }
};

function isValidPrintId(value) {
  return value !== null && value !== undefined && value !== '' && typeof value !== 'boolean';
}

function resolvePrintField(row, field) {
  if (!row || !field) return null;
  if (isValidPrintId(row[field])) return row[field];
  const foundKey = Object.keys(row).find((key) => {
    if (key === 'printid') return false;
    return (key.includes(field) || field.includes(key)) && isValidPrintId(row[key]);
  });
  return foundKey ? row[foundKey] : null;
}

export async function fallbackPrintFromChangeList(changeList, modules) {
  const rows = changeList || [];
  if (!rows.length) return [];
  const idKey = (modulesList[String(modules)] || {}).key?.[0];
  const groups = new Map();
  rows.forEach((row, index) => {
    const id = resolvePrintField(row, idKey) || ('row-' + index);
    const key = String(id);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(row);
  });
  const printDataList = [];
  for (const groupRows of groups.values()) {
    const data = { ...groupRows[0] };
    data.table = groupRows;
    data.tables = groupRows;
    data.mainList = groupRows;
    printDataList.push(await printDataParse(data));
  }
  return printDataList;
}

// 获取打印数据和打印数据处理返回
export async function processModules(
  that,
  changeList,
  modules,
  printFun,
  groupPrintFun,
  groupGet = false,
  supGet = false,
  filterList = [],
  filterKey = '',
  supKey = 'table',
  printOrderName = '',
  printDetailParamName = '',
  printDetailParamValue = ''
) {
  try {
    const printDataList = [];
    const moduleConfig = modulesList[modules + ''];
    if (!moduleConfig) {
      console.error('processModules: unknown modules', modules);
      return printDataList;
    }

    if (groupGet) {
      if (groupPrintFun) {
        const ks = moduleConfig.key[0];
        const ids = changeList
          .map((item) => {
            const key = Object.keys(item).find((k) => k.includes(ks) || ks.includes(k));
            return key ? item[key] : null;
          })
          .filter((value, index, self) => value != null && self.indexOf(value) === index);
        const groupKey = modulesGroupList[modules + '']?.key || 'ids';
        const form = { [groupKey]: ids };
        const isOld = that.isOld ?? false;
        let list = [];
        await groupPrintFun(form).then(async (res) => {
          if (!isOld) {
            list = res.data.data.dataList ?? res.data.data ?? [];
          } else {
            print(that, res.data.data, res.data.data.salesDeliveryDocDetailList);
          }
        });
        if (!list.length) {
          return printDataList;
        }
        const data = { ...list[0] };
        data.qrcode = `{"modules":${modules},"orderId":"${data[ks]}"}`;
        if (data.createUserId) {
          data.createUserName = await readUserSelect(data.createUserId);
        }
        data.mainList = [...list];
        data.tables = [...list];
        data.table = [...list];
        const parsedData = await printDataParse(data, true);
        printDataList.push(parsedData);
        return printDataList;
      }
      const data = { ...changeList[0] };
      data.mainList = [...changeList];
      printDataList.push(await printDataParse(data, true));
      return printDataList;
    }

    const promises = [];
    let oldForm = {};
    for (let k = 0; k < changeList.length; k++) {
      const key = moduleConfig.key;
      const value = moduleConfig.value;
      const values = value.map((it) => resolvePrintField(changeList[k], it));
      const form = {};
      key.forEach((it, id) => {
        form[it] = values[id];
      });
      const isOld = that.isOld ?? false;

      if (printFun) {
        let datakey;
        let datavalue;
        Object.keys(form).forEach((fk) => {
          if (isValidPrintId(form[fk])) {
            datakey = fk;
            datavalue = form[fk];
          }
        });
        if (!isValidPrintId(datavalue)) {
          continue;
        }
        if (JSON.stringify(oldForm) === JSON.stringify(form)) {
          continue;
        }
        oldForm = form;
        const row = changeList[k];
        promises.push(
          printFun(form)
            .then(async (res) => {
              if (!isOld) {
                const scalarFields = getNonObjectNonArrayItems(row);
                const printData = { ...scalarFields, ...(res && res.data && res.data.data) };
                printData.baseDrawingFile = row.baseDrawingFile;
                printData.valueImgList = row.valueImgList;
                printData.qrcode = JSON.stringify({
                  modules,
                  orderId: row[datakey] || datavalue
                });
                if (printData.createUserId) {
                  printData.createUserName = await readUserSelect(printData.createUserId);
                }
                printData.filterList = filterList;
                printData.filterKey = filterKey;
                const parsedData = await printDataParse(printData);
                if (supGet) {
                  const supData =
                    parsedData?.[supKey]?.length === 0
                      ? parsedData?.table
                      : parsedData?.[supKey];
                  (supData || []).forEach((it, ids) => {
                    const its = { ...getNonObjectNonArrayItems(parsedData), ...it };
                    its.table = [{ ...it }];
                    its.printId = ids;
                    printDataList.push(its);
                  });
                } else {
                  printDataList.push(parsedData);
                }
              }
            })
            .catch((error) => {
              console.error('processModules printFun', error);
            })
        );
      } else {
        changeList[k].tables = [{ ...changeList[k] }];
        await printDataParse(changeList[k]);
        printDataList.push(changeList[k]);
      }
    }
    await Promise.all(promises);
    if (!printDataList.length && changeList.length) {
      return fallbackPrintFromChangeList(changeList, modules);
    }
    return printDataList;
  } catch (error) {
    console.error('processModules', error);
    try {
      return await fallbackPrintFromChangeList(changeList, modules);
    } catch (fallbackError) {
      console.error('processModules fallback', fallbackError);
      return [];
    }
  }
}
